export default __webpack_public_path__ + "static/media/e-bunifikasi-picturemark-l.420eeb53.svg";